import { PAGE_LEVEL } from '@/constants';
export default {
  meta: { localeModules: ['recorder', 'summary', 'aiChat'] },
  // 语音转文字
  path: '/voice',
  redirect: '/voice/list',
  children: [
    {
      path: 'list',
      name: 'voiceList',
      component: () => import(/* webpackChunkName: 'voice' */ '@/pages/voice/list'),
      meta: {
        name: 'routers.voice_voice_to_text',
        componentName: 'VoiceListIndex',
        pageLevel: PAGE_LEVEL.FIRST,
        keepAlive: true
      }
    },
    {
      path: 'detail',
      name: 'voiceDetail',
      component: () => import(/* webpackChunkName: 'voice-detail' */ '@/pages/voice/summaryDetail'),
      meta: {
        name: 'routers.voice_detail',
        parent: '/voice/list',
        otherParent: ['/self-help/meeting/mine', '/self-help/meeting/history-summary-doc'],
        pageLevel: PAGE_LEVEL.THIRD,
        hideBreadcrumb: true, // 任务中心，录音转写 转写详情页，去除面包屑
        electronSingle: true,
        hideSecondMenu: true
      }
    },
    {
      path: 'summaryDetail',
      name: 'voiceSummaryDetail',
      component: () => import(/* webpackChunkName: 'voice-detail' */ '@/pages/voice/summaryDetail'),
      meta: {
        name: 'routers.voice_detail',
        parent: '/voice/list',
        otherParent: ['/self-help/meeting/mine', '/self-help/meeting/history-summary-doc'],
        pageLevel: PAGE_LEVEL.SECOND,
        electronSingle: true,
        hideBreadcrumb: true // BRM-云文档，转写详情页，去除面包屑
      }
    }
  ]
};
